module.exports = __webpack_public_path__ + "img/Step4.13c14f6e.png";